import { Error } from './auth.models';

/**
 * Contains all general models
 */
export interface Object {
  [key: string]: any;
}

export interface GeneralError {
  status: number;
  statusText: string;
}

// operation types

export enum OpTypes {
  CREATE = 'Create',
  UPDATE = 'Update',
  DELETE = 'Delete',
  FAILED = 'Failed',
  LOAD = 'Load',
  CHECKED = 'Checked'
}

export interface Operations {
  [key: string]: {
    type: OpTypes;
    error: Error | null;
    payload?: any;
  };
}

export interface Select2Data {
  value: string | number | boolean;
  label: string;
  value2?: string | number | boolean;
  disabled?: boolean;
  fieldType?: string;
  fieldSize?: number;
  generalType?: string;
  name?: string;
  tableId?: string;
  singularReference?: string;
  hide?:boolean,
  data?:string;
}

export interface Select2GroupData {
  label: string;
  options: Array<Select2Data>;
}
